/** Calendar days as YYYY-MM-DD strings in local time (the API's `date` filters use the same form). */

const pad = (n: number) => String(n).padStart(2, '0');

export function toDateKey(d: Date): string {
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export function fromDateKey(key: string): Date {
  const [y, m, d] = key.split('-').map(Number);
  return new Date(y!, m! - 1, d!);
}

export const todayKey = () => toDateKey(new Date());

/** "Today", "Yesterday", or "Sat, 3 Oct" (with the year when it isn't this year). */
export function formatDayLabel(key: string): string {
  const today = new Date();
  const yesterday = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);
  if (key === toDateKey(today)) return 'Today';
  if (key === toDateKey(yesterday)) return 'Yesterday';
  const d = fromDateKey(key);
  return d.toLocaleDateString('en-GB', {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    ...(d.getFullYear() !== today.getFullYear() && { year: 'numeric' }),
  });
}

/** Milliseconds from now until the next local midnight. */
export function msUntilMidnight(now = new Date()): number {
  return new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1).getTime() - now.getTime();
}
